//我的消息页面相关api
import $http from './http';
//获取我的消息列表
export function getMessageList(data) {
    return $http({
        url: `/xmt/myMessage/list`,
        data,
        method: 'get'
    });
}
//更新已读状态
export function updateReadState(data) {
    return $http({
        url: `/xmt/myMessage/updateMessage4Read`,
        data,
        method: 'post'
    });
}
